import React, { useEffect, useState } from "react" 
import { Document, Page, pdfjs  } from 'react-pdf';
import { queryTools, cn, randoms } from "lib/utils"
import { UnitTitleBlock } from "lib/components"
import { fetchpaths } from "./data/fetchpaths"

export default function ComparisonTool(){

  const { data:_Templates } = queryTools.resource.parseQueryForApi("template.findAll", {})

  const defaultTestData = { 
    ready: false,
    tb2Templates: [], 
    tb3Templates: [], 
    tb2Template: null, 
    tb3Template: null, 
    tb3PdfLocation: null,
    rp: "",
    subdomain: "",
    height: 40,
    tb2Html: "", 
    tb3Html: "" 
  }

  const [ testingData, setTestingData ] = useState<any>(defaultTestData)

  const headers = { "apikey": "mm33dr$reH6F4" }

  const injectScaling = (vers:number, html: any, scale = 0.65):any => {
    const scalingStyle = `
      <style>
        html, body {
          margin: 0 !important;
          padding: 0 !important;
          transform: scale(${scale});
          transform-origin: top left;
          overflow: visible !important;
          width: ${100 / scale}% !important;
          height: ${100 / scale}% !important;
        }
      </style>
    `;
  
    const code = (vers === 3 ) ? JSON.parse(html) : html
    return code.replace(/<head>/i, `<head>${scalingStyle}`);
  }
  

  const handleTemplate2Change = (e:any) => setTestingData({ ...testingData, tb2Template: e.target.value, height: 40 })
  const handleTemplate3Change = (e:any) => setTestingData({ ...testingData, tb3Template: e.target.value, height: 40 })
  const handleRpChange = (e:any) => setTestingData({ ...testingData, rp: e.target.value })
  const handleSubdomainChange = (e:any) => setTestingData({ ...testingData, subdomain: e.target.value, height: 40 })
  const increaseHeight = () => setTestingData({ ...testingData, height: testingData.height + 50 })


  const getSelectedTemplate = (e:any) => {
    const selectedTemplate = _Templates.find((tmpl:any) => tmpl._id === e.target.value)
    if( selectedTemplate ){
      setTestingData({ ...testingData, tb3Template: selectedTemplate, height: 40 })
    }
  }

  const getAllTb2Templates = async() => {
    const basepath = (process.env.NODE_ENV === "production") ? fetchpaths.tb2.prod : fetchpaths.tb2.dev
    const resp = await fetch(`${basepath}/template`, { method: "GET", headers: headers })
    const data = await resp.json()
    console.log(data)
    setTestingData((prev:any) => ({ ...prev, tb2Templates: data.payload }) )
  }

  const getAllTb3Templates = async() => {
    const basepath = (process.env.NODE_ENV === "production") ? fetchpaths.tb3.prod : fetchpaths.tb3.dev
    const resp = await fetch(`${basepath}/dispute`, { method: "GET", headers: headers })
    const data = await resp.json()
    console.log(data)
    setTestingData((prev:any) => ({ ...prev, tb3Templates: data.payload }) )
  }

  const fetchTb2Template = async() => {
    const basepath = (process.env.NODE_ENV === "production") ? fetchpaths.tb2.prod : fetchpaths.tb2.dev
    const tmpl = testingData.tb2Template
    const rp = testingData.rp
    const subdomain = testingData.subdomain
    const path = `${basepath}/html/${tmpl}?rpid=${rp}&subdomain=${subdomain}&simulatemm=true&version=argent&design=defleppard`
    console.log(path)
    const resp = await fetch(path, { method: "GET", headers: headers })
    const data = await resp.json()
    console.log(data)
    if( data.status === "success" ){
      setTestingData({ ...testingData, tb2Html: injectScaling(2, data.payload.html) })
    }
  }

  const fetchTb3Template = async() => {
    const basepath = (process.env.NODE_ENV === "production") ? fetchpaths.tb3.prod : fetchpaths.tb3.dev
    const tmpl = testingData.tb3Template
    const rp = testingData.rp
    const subdomain = testingData.subdomain
    const path = `${basepath}/html/${tmpl}?rpid=${rp}&subdomain=${subdomain}&pdf=none&format=json`
    const resp = await fetch(path, { method: "GET", headers: headers })
    const result = await resp.json()
    if( result ){
      setTestingData({ ...testingData, tb3Html: injectScaling(3, JSON.stringify(result.data)) })
    }
  }

  const fieldClasses = "h-8 border border-solid border-slate-700 rounded-sm bg-transparent px-2 flex items-center focus:outline-none focus:border-slate-900"

  useEffect(() => {
    console.log(testingData.tb2Templates)
  },[testingData.tb2Templates])

  useEffect(() => {
    getAllTb2Templates()
    getAllTb3Templates()
  },[])

  if( !testingData.tb2Templates ) return <></>
  return (
    <div className={cn("w-full pt-6 pb-36")}>
      <UnitTitleBlock className="left-[10px] w-[calc(100%+10px)]" title="Comparison Tool" />

      <div className="w-full flex justify-start items-stretch gap-10">

        <div className="w-6/12 flex flex-col gap-2">
          <h2>Template Builder 2</h2>
          <div className="w-full flex flex-col">
            <select
              className={cn(fieldClasses, "w-full")}
              onChange={handleTemplate2Change}
            >
              <option value="" className="bg-slate-800">Choose a template</option>
              { testingData.tb2Templates.filter((tmpl:any) => tmpl.Title.length > 0).map((template: any) => (
                <option key={template._id} value={template.Id} className="bg-slate-800">
                  {template.Title}
                </option>
              ))}
            </select>
          </div>
          <div className="w-full flex justify-start items-center gap-3">
            <input 
              type="text" 
              name="tb2-rp" 
              id="tb2-rp" 
              placeholder="rp" 
              className={cn(fieldClasses, "w-3/12 text-gray-50")}
              value={testingData.rp}
              onChange={(e:any) => handleRpChange(e)} 
            />
            <input 
              type="text" 
              name="tb2-subdomain" 
              id="tb2-subdomain" 
              placeholder="subdomain" 
              className={cn(fieldClasses, "w-7/12 text-gray-50")}
              value={testingData.subdomain}
              onChange={(e:any) => handleSubdomainChange(e)} 
            />
            <button 
              onClick={fetchTb2Template}
              className={cn(fieldClasses, "w-2/12 bg-teal-800 text-sm uppercase flex justify-center")}
            >
              Fetch
            </button>
          </div>

          <div 
            className={cn("mt-4 border border-solid border-slate-700 relative bg-white")}
          >
            { testingData.tb2Html !== null && (
              <iframe
                srcDoc={testingData.tb2Html}
                title="Legacy View"
                sandbox=""
                scrolling="yes"
                className="w-full h-full overflow-auto"
                style={{ height: `${testingData.height}rem` }}
              />
            )}
            <p 
              onClick={increaseHeight}
              className="absolute bottom-[-30px] left-0 mt-10 text-sm text-center text-slate-500"
            >
              show more
            </p>
          </div>
        </div>



        <div className="w-6/12 flex flex-col gap-2">
          <h2>Template Builder 3</h2>
          <div className="w-full flex flex-col">
          <select
              className={cn(fieldClasses, "w-full")}
              onChange={handleTemplate3Change}
            >
              <option value="" className="bg-slate-800">Choose a template</option>
              { testingData.tb3Templates.filter((tmpl:any) => tmpl.title.length > 0).map((template: any) => (
                <option key={template._id} value={template.Id} className="bg-slate-800">
                  {template.title}
                </option>
              ))}
            </select>
          </div>
          <div className="w-full flex justify-start items-center gap-3">
            <input 
              type="text" 
              name="tb3-rp" 
              id="tb3-rp" 
              placeholder="same rp as tb2" 
              readOnly={true}
              className={cn(fieldClasses, "w-3/12 opacity-50 cursor-not-allowed text-gray-50")}
              value={testingData.rp}
              />
            <input 
              type="text" 
              name="tb3-subdomain" 
              id="tb3-subdomain" 
              placeholder="same subdomain as tb2" 
              readOnly={true}
              className={cn(fieldClasses, "w-7/12 opacity-50 cursor-not-allowed")}
              value={testingData.subdomain}
            />
            <button 
              onClick={fetchTb3Template}
              // onClick={() => setTestingData({...testingData, ready: true})}
              className={cn(fieldClasses, "w-2/12 bg-teal-800 text-sm uppercase flex justify-center")}
            >
              Fetch
            </button>
          </div>

          <div 
            className={cn("mt-4 border border-solid border-slate-700 relative bg-white")}
          >
            { testingData.tb3Html !== null && (
              <iframe
                srcDoc={testingData.tb3Html}
                title="Legacy View"
                sandbox=""
                scrolling="yes"
                className="w-full h-full overflow-auto"
                style={{ height: `${testingData.height}rem` }}
              />
            )}
            <p 
              onClick={increaseHeight}
              className="absolute bottom-[-30px] left-0 mt-10 text-sm text-center text-slate-500"
            >
              show more
            </p>
          </div>
          
          {/* { testingData.ready === true && (
            <div className="w-full scale-50">
              <TemplateRenderWrapper
                ready={true}
                template={testingData.tb3Template}
                subdomain={testingData.subdomain}
                rp={testingData.rp}
                renderconfig={{ 
                  mode: "page", 
                  height: "700px", 
                  width: "500px",
                  scale: 0.5,
                }}
              />
            </div>
          )} */}
        </div>

      </div>

    </div>
  )
}